import styles from "./AppFooter.module.css"

export function AppFooter() {
  const buildVersion = __BUILD_VERSION__

  // Format the version to be more readable
  const formatVersion = (version: string) => {
    if (version === "dev") {
      return "Development"
    }

    const parts = version.split("-")
    if (parts.length === 3) {
      const [sha, runId, runNumber] = parts
      const shortSha = sha.substring(0, 7)
      return `${shortSha} • ${runId} • #${runNumber}`
    }

    return version
  }

  return (
    <footer className={styles.footer}>
      <p className={styles.version}>v{formatVersion(buildVersion)}</p>
    </footer>
  )
}
